export const MAX_DEPTH = 5;
export const MAX_HP = 5;
export const FLAG_SCORE = 100;
export const ROWS = 16;
export const COLUMNS = 16;
export const STATUS = {
  START: 'START',
  GAME_OVER: 'GAME_OVER',
  AUTO: 'AUTO',
  FLAG: 'FLAG',
};
export const TITLE = 'Dungeons v1.0.2';
